import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import Icon from '../../core/Icon/Icon';
import { withStyles, createStyles } from '@material-ui/core/styles';
var styles = createStyles({
  base: {
    fontSize: 'inherit',
    position: 'relative',
    width: '1.5em',
    textAlign: 'left'
  },
  coloredMilestone: {
    transform: 'rotate(45deg)',
    border: '1px solid transparent',
    display: 'inline-block',
    width: 9,
    height: 9,
    marginLeft: 3,
    marginRight: 4
  }
});
/**
 * @param {import('../types').FormatterProps<'touchpoint' | 'milestone'> & { color?: string, style?: import('react').CSSProperties } & import('@material-ui/core').WithStyles<typeof styles>} props
 */

var JourneyTouchpointIcon = function JourneyTouchpointIcon(_ref) {
  var value = _ref.value,
      color = _ref.color,
      style = _ref.style,
      classes = _ref.classes;
  var icon = null;

  if (value === 'milestone' && color) {
    var allStyle = {
      backgroundColor: color
    };
    var useBorder = color === '#FFF' || color === 'rgb(255, 255, 255)';
    if (useBorder) allStyle.borderColor = '#222';
    icon = React.createElement("span", {
      style: _objectSpread({
        position: 'relative',
        display: 'inline-block'
      }, style)
    }, React.createElement("span", {
      className: classes.coloredMilestone,
      style: allStyle
    }));
  } else {
    if (!color) color = '#000';
    icon = React.createElement(Icon, {
      type: value,
      style: _objectSpread({
        color: color
      }, style),
      className: classes.base
    });
  }

  return icon;
};

JourneyTouchpointIcon.defaultProps = {
  style: {}
};
export default withStyles(styles, {
  name: 'ECJourneyTouchpointIcon'
})(JourneyTouchpointIcon);